var map = {
	"./1.png": 94,
	"./2.png": 95,
	"./3.png": 96,
	"./53w5.png": 97,
	"./about.png": 98,
	"./bullet.svg": 20,
	"./faqup.png": 16,
	"./favicon.psd": 99,
	"./guest/1.jpg": 21,
	"./guest/2.jpg": 22,
	"./guest/3.jpg": 23,
	"./impressive.png": 100,
	"./innovative.png": 101,
	"./leftArrowOutline.png": 12,
	"./leftArrowSolid.png": 13,
	"./leftdoublearrow.png": 24,
	"./logo_shopee_h.png": 10,
	"./logo_shopee_v.png": 102,
	"./partners/1.jpg": 25,
	"./partners/CoBrand-BusinessSchool-COLS.jpg": 26,
	"./partners/DigiPen_Singapore_WEB_RED.jpg": 27,
	"./partners/Engin_Club.png": 28,
	"./partners/IEEE_NUS_Student Branch_logo.jpeg": 29,
	"./partners/IEEE_SUTD.png": 30,
	"./partners/IES_SIT.jpg": 31,
	"./partners/IET_ON_CAMPUS.png": 32,
	"./partners/IMDA.jpg": 33,
	"./partners/Institute_Engineers_SUTD.jpg": 34,
	"./partners/Institution_Engineers_NUS.jpg": 35,
	"./partners/LLI.jpg": 36,
	"./partners/Lato_Reactor_School.png": 37,
	"./partners/NCCUCG.png": 38,
	"./partners/NTU EEE Alumni Association.png": 39,
	"./partners/NTU_CEE.jpg": 103,
	"./partners/NTU_College_of_Engineering.jpg": 40,
	"./partners/NTU_ML&DA.JPG": 41,
	"./partners/NTUitive.jpg": 42,
	"./partners/NUS MSL Logo.jpg": 43,
	"./partners/NUS-BACT_Logo.png": 44,
	"./partners/NUS_Fintech.png": 45,
	"./partners/NUS_Future-ready_Graduates.png": 104,
	"./partners/NUS_Graduates.png": 105,
	"./partners/NUS_ISS.png": 46,
	"./partners/NUS_Industrial&Systems_Engineering.png": 47,
	"./partners/NUS_Statistics_Society.png": 48,
	"./partners/NUS_school_computing.png": 49,
	"./partners/OAR.png": 50,
	"./partners/Roboto_Coding_Academy.png": 51,
	"./partners/Rocket_Academ.png": 106,
	"./partners/SIT Geeks.png": 52,
	"./partners/SIT_Logo.png": 53,
	"./partners/SMU.png": 54,
	"./partners/SMU_EllipSIS.jpg": 55,
	"./partners/SUTD_logo.png": 9,
	"./partners/TeSA.png": 56,
	"./partners/Technology Club - Full v2.png": 57,
	"./partners/disg.png": 58,
	"./partners/dotnetsg.png": 59,
	"./partners/ieeentu.png": 60,
	"./partners/mergopher.png": 107,
	"./partners/ntu.jpg": 61,
	"./partners/ntueirc.png": 62,
	"./partners/nus.png": 63,
	"./partners/nus_comp_club.png": 64,
	"./partners/pad.png": 65,
	"./partners/pugs-logo.png": 108,
	"./partners/pydata-logo-banner.png": 66,
	"./partners/shopee_logo_en.jpg": 109,
	"./partners/shopee_logo_en.png": 67,
	"./partners/smartacadem.png": 68,
	"./partners/vertical_Institute.png": 69,
	"./popular.svg": 110,
	"./rightArrowOutlineWhite.png": 15,
	"./rightArrowSolid.png": 14,
	"./rightdoublearrow.png": 70,
	"./rightpointicon.png": 71,
	"./theme.png": 111,
	"./ultra.jpg": 112,
	"./ultra_hack_logo.png": 11,
	"./whyshouldyoujoin.png": 113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;